<template>
	<div>
		<div class="subbar" v-if="instance" style="background-color: #f7f5f9">
			<div class="dF aC mb-0">
				<div class="breadcrumbs" style="align-items: center; display: block !important">
					<a-breadcrumb>
						<a-breadcrumb-item>{{
							instance.name
						}}</a-breadcrumb-item>
						<a-breadcrumb-item>{{
							selectedAppInitial
						}}</a-breadcrumb-item>
						<a-breadcrumb-item style="color: var(--orange)">{{
							sidebarSelection
						}}</a-breadcrumb-item>
					</a-breadcrumb>
				</div>

				<div v-if="$route.path == '/'" class="dF aC ml-auto d-none d-sm-flex">
					<template>
						<a-auto-complete size="large" v-model="tempSearch" style="width: 250px"
							placeholder="Search for a workflow..." :dropdown-style="{ width: '250px' }"
							@search="handleSearch" class="searchBar" allowClear>
							<a-input>
								<a-icon slot="prefix" type="search" />
							</a-input>
						</a-auto-complete>
					</template>

					<div class="mx-4 d-none d-xl-block dash-divider" />
					<a-button @click="addNew" type="primary" icon="plus" size="large">ADD A WORKFLOW</a-button>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import { getAppIcon } from "bh-mod";

	export default {
		data() {
			return {
				tempSearch: "",
			};
		},
		watch: {
			$route: {
				immediate: true,
				handler() {
					this.tempSearch = this.$store.state.globalSearch;
				},
			},
		},
		computed: {
			selectedAppInitial() {
				return this.$store.state.theApp?.media?.initial || "MA";
			},
			sidebarSelection() {
				return this.$store.state.sidebarSelection;
			},
			instance() {
				return this.$store.state.instance;
			},
			theApp() {
				return this.$store.state.theApp || {};
			},
		},
		methods: {
			handleSearch(input) {
				let search = input && input.trim() || ''
				this.$store.commit("UPDATE_GLOBAL_SEARCH", search.toLowerCase())
			},
			addNew() {
				if (this.$p < 40) return this.$message.error('You do not have permission to create new workflow')

				if (this.$route.path !== "/workflow/create") {
					this.$router.push('/workflow/create')
				}
			},
			getAppIcon,
		},
	};
</script>
<style lang="scss">
	.ant-form-horizontal.search-horizontal {
		.ant-form-item-control-wrapper {
			flex: 1;
		}

		.ant-form-item {
			display: flex;
		}

		.ant-form-item-label {
			min-width: 100px;
		}
	}

	.ant-select-auto-complete.ant-select .ant-select-selection__placeholder {
		margin-left: 32px;
	}
</style>
